// @ts-strict-ignore
import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  OnDestroy,
  OnInit
} from '@angular/core';
import { LMColumnsBaseComponent } from './lm-columns-base.component';
import { LMConditionUtilService } from '@utils/lm-condition-util.service';
import { LMFormLayoutService } from '@form/services/lm-form-layout.service';
import { LMLayoutUtilDirective } from './lm-layout-util.directive';
import { LMLoggerService } from '@app/services';
import { cloneDeep } from "lodash-es";

@Component({
  selector: 'lm-columns-image-first-column',
  templateUrl: 'lm-columns-image-first-column.component.html',
  styleUrls: [ './lm-columns-image-first-column.component.scss' ],
  providers: [ LMLayoutUtilDirective, LMFormLayoutService ],
  changeDetection: ChangeDetectionStrategy.OnPush
})

export class LMColumnsImageFirstColumnComponent extends LMColumnsBaseComponent implements OnInit, OnDestroy {

  private subscribers = [];

  constructor(
    protected lmConditionUtilService: LMConditionUtilService,
    protected lmFormLayoutService: LMFormLayoutService,
    protected lmLoggerService: LMLoggerService,
    protected changeDetectorRef: ChangeDetectorRef
  ) {
    super(lmConditionUtilService, lmFormLayoutService, lmLoggerService, changeDetectorRef);
  }

  public columns: Array<LMFormLayoutColumnUi>;
  public imageColumn: Array<LMFormLayoutColumn> = [];

  ngOnInit() {
    super.ngOnInit();

    this.imageColumn.push(this.layoutObject.columns[0]);
    this.imageColumn.forEach((column, i) => {
      column.index = i;
    });

    // cant change the spec
    const cloneLayout = cloneDeep(this.layoutObject);
    cloneLayout.columns.shift();

    cloneLayout.columns.forEach((column, i) => {
      column.index = i;
    });
    this.columns = cloneLayout.columns;
  }

  ngOnDestroy() {
    this.subscribers.forEach(subscription => subscription.unsubscribe());
  }
}
